import React, { forwardRef } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";

import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import ThreatModelerMappingForm from "./ThreatModelerMappingForm";

const ThreatModelerCredentialsForm = (props, ref) => {
  const fields = [
    {
      name: "apiEndpoint",
      label: "Base URL",
      rules: [urlRegexValidator],
      required: true,
    },
    {
      name: "apiToken",
      label: "API Token",
      type: FieldTypes.PASSWORD,
      required: true,
    },
  ];

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={ThreatModelerMappingForm}
    />
  );
};

export default forwardRef(ThreatModelerCredentialsForm);